import React from 'react';
import SucceedoLogin from '../components/Succeedo/Auth/SucceedoLogin';

const SucceedoLoginContainer = (props, _railsContext) => {
  return <SucceedoLogin {...props} />;
};

export default SucceedoLoginContainer;
